import { Alert } from '@avantstay/backoffice-core'

const SESSION_ALERT_INTERVAL_MS = 5 * 60_000

let lastShownAt = Number.NEGATIVE_INFINITY

/**
 * Tells the user their session could not be authenticated (an HTTP 401) and offers a reload, which
 * signs them in again. A 401 is never a permissions problem. The alert stays until dismissed, since
 * requests keep failing until the user acts, and a busy page can send many requests at once, so it
 * is shown at most once every five minutes.
 */
export const showSessionExpiredAlert = () => {
  const now = Date.now()
  if (now - lastShownAt < SESSION_ALERT_INTERVAL_MS) return
  lastShownAt = now

  Alert.Error('Your session could not be verified. Reload the page to sign in again.', {
    actions: [{ label: 'Reload', onClick: () => window.location.reload() }],
    timeout: -1,
  })
}
